// src/previewTypes.ts
var MAX_PREVIEW_SIZE = 30 * 1024 * 1024;
var PREVIEWABLE_MIME_PREFIXES = ["image/", "video/", "audio/", "text/"];
var FONT_EXTENSIONS = [".ttf", ".otf", ".woff", ".woff2", ".eot"];
var ARCHIVE_EXTENSIONS = [".zip", ".rar", ".7z", ".tar", ".gz", ".bz2", ".xz", ".tar.gz", ".tar.bz2", ".tar.xz"];
var EPUB_EXTENSIONS = [".epub"];
function getFileExtension(fileName) {
  const lastDotIndex = fileName.lastIndexOf(".");
  return lastDotIndex !== -1 ? fileName.substring(lastDotIndex).toLowerCase() : "";
}
function isPreviewable(mimeType, fileName) {
  if (!mimeType) {
    const ext = getFileExtension(fileName);
    if (EPUB_EXTENSIONS.includes(ext)) {
      return { previewable: true, type: "epub" };
    }
    if (FONT_EXTENSIONS.includes(ext)) {
      return { previewable: true, type: "font" };
    }
    if (ARCHIVE_EXTENSIONS.includes(ext)) {
      return { previewable: true, type: "archive" };
    }
    return { previewable: false, type: "unknown" };
  }
  if (mimeType.startsWith("image/")) {
    return { previewable: true, type: "image" };
  }
  if (mimeType.startsWith("video/")) {
    return { previewable: true, type: "video" };
  }
  if (mimeType.startsWith("audio/")) {
    return { previewable: true, type: "audio" };
  }
  if (mimeType === "application/pdf") {
    return { previewable: true, type: "pdf" };
  }
  if (mimeType === "application/epub+zip" || mimeType === "application/epub") {
    return { previewable: true, type: "epub" };
  }
  if (mimeType.startsWith("font/") || mimeType.includes("font")) {
    return { previewable: true, type: "font" };
  }
  if (mimeType === "application/zip" || mimeType === "application/x-zip-compressed" || mimeType === "application/x-rar-compressed" || mimeType === "application/x-7z-compressed" || mimeType === "application/x-tar" || mimeType === "application/x-gzip" || mimeType === "application/x-bzip2" || mimeType === "application/x-xz" || mimeType === "application/vnd.rar") {
    return { previewable: true, type: "archive" };
  }
  if (mimeType.startsWith("text/")) {
    if (fileName.endsWith(".md")) {
      return { previewable: true, type: "markdown" };
    }
    return { previewable: true, type: "text" };
  }
  if (["application/json", "application/xml", "application/javascript", "application/typescript"].includes(mimeType)) {
    return { previewable: true, type: "code" };
  }
  return { previewable: false, type: "unknown" };
}
function getPreviewConfig(mimeType, fileName, fileSize) {
  const { previewable, type } = isPreviewable(mimeType, fileName);
  return {
    type,
    previewable: previewable && fileSize <= MAX_PREVIEW_SIZE,
    maxSize: MAX_PREVIEW_SIZE,
    streamable: ["video", "audio"].includes(type),
    localRender: ["image", "video", "audio", "pdf", "text", "markdown", "code", "epub", "font"].includes(type)
  };
}
export {
  ARCHIVE_EXTENSIONS,
  EPUB_EXTENSIONS,
  FONT_EXTENSIONS,
  MAX_PREVIEW_SIZE,
  PREVIEWABLE_MIME_PREFIXES,
  getFileExtension,
  getPreviewConfig,
  isPreviewable
};
//# sourceMappingURL=previewTypes.js.map